const print = (orderId: string) => {
  const url = `${window.location.origin}/print-order/${orderId}`
  const printPage = window.open(url, '_blank')
  if (printPage) printPage.onafterprint = printPage.close
}

export { print }
